export default {"src":"/_next/static/media/netflix.24fcc364.svg","height":35,"width":127};